import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=456f4f3f&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456f4f3f')) {
      api.createRecord('456f4f3f', component.options)
    } else {
      api.reload('456f4f3f', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=456f4f3f&", function () {
      api.rerender('456f4f3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N9BvJYRX6gNs/JS/offershelp.vue"
export default component.exports